(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,2597,5901,442,9600,8960,2274],{

/***/ 82776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 3 modules
var DemoForm = __webpack_require__(98960);
// EXTERNAL MODULE: ../../libs/utils/useInView/index.ts + 1 modules
var useInView = __webpack_require__(85807);
// EXTERNAL MODULE: ../../libs/utils/useLottie/useLottie.tsx
var useLottie = __webpack_require__(73849);
// EXTERNAL MODULE: ./src/views/Home/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(67883);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/Home/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(40413);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/Home/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(19903);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
;// CONCATENATED MODULE: ./src/views/Home/components/Hero/assets/illo-hero-leading-customer-ai-powered_F2.json.data
/* harmony default export */ var illo_hero_leading_customer_ai_powered_F2_json = ("/_next/static/data/illo-hero-leading-customer-ai-powered_F2.json-ca6469cd9436b25c340e8e2d22a15a1a.json");
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Home/components/Hero/Hero.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var copy = {
  heading: "The leading customer data platform, powered by CustomerAI",
  description: "Twilio Segment brings together clean, consented customer data for real-time insights so you can know each individual like they are your only customer."
};

var Hero = function Hero(_ref) {
  var externalAppearance = _ref.appearance;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);

  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(illo_hero_leading_customer_ai_powered_F2_json));
  }, []);

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      autoplay: true,
      animationData: animationData,
      loop: true
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView) {
      animation === null || animation === void 0 ? void 0 : animation.play();
    }
  }, [animation, isInView]);

  var afterContent = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SignupButton/* SignupButtonText */._, {
    size: "medium",
    tag: "a",
    appearance: appearance,
    children: ["Create a free account", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})]
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
        variant: "2Col",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "homeH2",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "homePXXL",
            tag: "p",
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoFormContainer, {
              "data-hook": "demoFormContainer",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
                isProgressive: true,
                after: afterContent
              })
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
          children: animationData ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Animation, {
            ref: containerRef
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
              type: "image/webp",
              srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
              width: "641",
              height: "541",
              src: (Hero_2x_default()),
              alt: "Illustration: Customer Data Platform diagram",
              loading: "eager"
            })]
          })
        })]
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e49f09n3"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e49f09n2"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:50px;}" + ( true ? "" : 0));

var DemoFormContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e49f09n1"
} : 0)("margin-top:50px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{margin-top:0;}" + ( true ? "" : 0));

var Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e49f09n0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/TestimonialSlider/index.ts + 11 modules
var TestimonialSlider = __webpack_require__(88302);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 250 modules
var CompanyMono = __webpack_require__(68536);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 258 modules
var Company = __webpack_require__(13922);
;// CONCATENATED MODULE: ./src/views/Home/components/TestimonialsSlider/data.tsx







var testimonialData = function testimonialData() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return [{
    company: "allergan",
    text: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: ["\u201CWe lean heavily on Segment today to identify our consumers and their profile traits, what makes them them, and what kind of journey they are on. So, being able to have that integration with Twilio to be able to", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mark", {
        children: "send communications to users based on their journey status is a pivotal piece of bringing those magic moments to life"
      }), ".\u201C"]
    }),
    name: "Tory Brady",
    position: "Associate Vice President, Product, Engineering & Data at Allergan Data Labs",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* AllerganMonoLogo */.ubl, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* AllerganLogo */.Rko, {}),
    logoName: "Allergan",
    extendedText: "in sales driven in 2021 YTD by direct-to-consumer (DTC)"
  }, {
    company: "ibm",
    text: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: ["\u201CWith real-time integrated data flows from Segment, we can truly", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mark", {
        children: "understand what people are doing"
      }), " ", "with our platform.\u201D"]
    }),
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* IbmMonoLogo */.cEr, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* IbmLogo */.D64, {}),
    logoName: "Ibm"
  }, {
    company: "sanofi",
    text: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: ["\u201CThe process before Segment was much more cumbersome and difficult to explain to marketers. Now, Segment allows us to compile data all in one place, forming a Golden Profile, and allows for other teams to", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mark", {
        children: "easily utilize and activate data"
      }), ".\u201C"]
    }),
    name: "Rick Troiani",
    position: "Director of Omni-Channel Engagement Architecture, Sanofi",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SanofiMonoLogo */.he8, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* SanofiLogo */.usZ, {}),
    logoName: "sanofi",
    extendedRate: "93%",
    extendedText: "time saved adding new data sources",
    extendedLink: "/customers/sanofi/"
  }, {
    company: "mongodb",
    text: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: ["\u201CSince implementing Segment we have seen a significant increase in revenue which we attribute to the", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mark", {
        children: "improved targeting and personalization of our communications"
      }), ".\u201C"]
    }),
    name: "Ale Dimitriu",
    position: "Senior Marketing Operations Manager, MongoDB",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MongoDbMonoLogo */.N2M, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* MongoDbLogo */.ZEv, {}),
    logoName: "mongodb",
    extendedRate: "100x",
    extendedText: "increased registration rates",
    extendedLink: "/customers/mongodb/"
  }, {
    text: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: ["\u201CHaving Segment not only helped us do the personalization work we\u2019ve always wanted to do, but we can now", " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mark", {
        children: "improve on the effectiveness of our ad campaigns"
      }), " ", "and create a better feedback loop.\u201D"]
    }),
    company: "dominos",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DominosMonoLogo */.ooH, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* DominosLogo */.MYS, {}),
    logoName: "Domino's",
    extendedText: "decreased cost per acquisition"
  }];
};


;// CONCATENATED MODULE: ./src/views/Home/components/TestimonialsSlider/TestimonialsSlider.tsx


function TestimonialsSlider_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var TestimonialsSlider_copy = {
  heading: "The world\u2019s leading brands are powered by Twilio Segment",
  description: "From startups to global enterprises, see what businesses have achieved with the Twilio Segment customer data platform."
};

var TestimonialsSlider = function TestimonialsSlider() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "homeH2",
          tag: "h2",
          children: TestimonialsSlider_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "homePExtraLarge",
          tag: "p",
          children: TestimonialsSlider_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: "twilioDark",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider["default"], {
        data: testimonialData,
        innerStyles: false,
        title: false
      })
    })]
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "emty7x80"
} : 0)( true ? {
  name: "etts4h",
  styles: "max-width:1260px;overflow-x:visible"
} : 0);

/* harmony default export */ var TestimonialsSlider_TestimonialsSlider = (TestimonialsSlider);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/Home/components/TheGrowthReport/assets/TheGrowthReport@2x.png
var TheGrowthReport_2x = __webpack_require__(26614);
var TheGrowthReport_2x_default = /*#__PURE__*/__webpack_require__.n(TheGrowthReport_2x);
// EXTERNAL MODULE: ./src/views/Home/components/TheGrowthReport/assets/TheGrowthReport.webp
var assets_TheGrowthReport = __webpack_require__(90004);
var TheGrowthReport_default = /*#__PURE__*/__webpack_require__.n(assets_TheGrowthReport);
// EXTERNAL MODULE: ./src/views/Home/components/TheGrowthReport/assets/TheGrowthReport@2x.webp
var assets_TheGrowthReport_2x = __webpack_require__(39565);
var assets_TheGrowthReport_2x_default = /*#__PURE__*/__webpack_require__.n(assets_TheGrowthReport_2x);
;// CONCATENATED MODULE: ./src/views/Home/components/TheGrowthReport/TheGrowthReport.tsx


function TheGrowthReport_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var TheGrowthReport_copy = {
  heading: "The Growth Report 2023: AI Edition",
  description: "Get insights from 2,450 marketing and CX leaders on what it means to grow sustainably in 2023, and how companies are using AI to do just that.",
  button: {
    text: "Read it here",
    href: "/the-growth-report"
  }
};

var TheGrowthReport = function TheGrowthReport() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TheGrowthReport_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TheGrowthReport_StyledSection, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        alignSelf: "center",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "homeH3",
          tag: "h2",
          children: TheGrowthReport_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "homePExtraLarge",
          tag: "p",
          children: TheGrowthReport_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            size: "large",
            color: "primary",
            variant: "filled",
            href: (0,getAbsoluteUrl/* default */.Z)(TheGrowthReport_copy.button.href, pageConfig),
            children: TheGrowthReport_copy.button.text
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((TheGrowthReport_default()), ", ").concat((assets_TheGrowthReport_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
            src: (TheGrowthReport_2x_default()),
            alt: "The Growth Report",
            width: "744",
            height: "589",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var TheGrowthReport_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebvby213"
} : 0)( true ? "" : 0);

var TheGrowthReport_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ebvby212"
} : 0)(Section/* Wrapper */.im, "{gap:80px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{gap:40px;}}" + ( true ? "" : 0));

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebvby211"
} : 0)( true ? {
  name: "iqoq9n",
  styles: "margin-top:20px"
} : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "ebvby210"
} : 0)("width:100%;max-width:500px;filter:drop-shadow(", function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var TheGrowthReport_TheGrowthReport = (TheGrowthReport);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ./src/views/Home/components/GettingStarted/GettingStarted.tsx


function GettingStarted_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var GettingStarted_copy = {
  heading: "See Twilio Segment in action",
  description: "Learn how you can start connecting your data with Twilio Segment. <a href=\"/pricing\">Explore our plans</a> to find the one that\u2019s right for your team.",
  caption: "*  Twilio is the #1 CDP for market share four years in a row per IDC (2019-2022).",
  caption2: "** Statistics from 6/30/22 - 6/30/23"
};
var buttons = [{
  text: "View interactive demo",
  href: "/product-tour?utm_source=site&utm_medium=referral&utm_campaign=homepage/",
  variant: "filled"
}, {
  text: "Pricing",
  href: "/pricing/",
  variant: "outlined"
}];

var GettingStarted = function GettingStarted() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "homeH2",
          tag: "h2",
          children: GettingStarted_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
          variant: "homePExtraLarge",
          tag: "p",
          dangerouslySetInnerHTML: {
            __html: sanitize_html_default()(GettingStarted_copy.description, {
              allowedTags: ["a"]
            })
          }
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonsWrapper, {
          children: buttons.map(function (button) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              size: "large",
              color: "primary",
              variant: button.variant,
              href: (0,getAbsoluteUrl/* default */.Z)(button.href, pageConfig),
              children: button.text
            }, button.text);
          })
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
        tokens: {
          color: theme.palette.twilio.gray[40]
        }
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Caption, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
        variant: "pSmall",
        children: GettingStarted_copy.caption
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
        variant: "pSmall",
        children: GettingStarted_copy.caption2
      })]
    })]
  });
};

var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edlxz8s6"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return (0,polished_esm/* transparentize */.DZ)(0.85, theme.palette.twilio.mint[100]);
}, ";" + ( true ? "" : 0));

var GettingStarted_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "edlxz8s5"
} : 0)(Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{gap:40px;}}" + ( true ? "" : 0));

var ButtonsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edlxz8s4"
} : 0)("display:flex;gap:24px;justify-content:center;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{flex-direction:column;}" + ( true ? "" : 0));

var DividerSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edlxz8s3"
} : 0)( true ? {
  name: "2en4lt",
  styles: "max-width:1248px;margin:0 auto;padding:0 24px"
} : 0);

var Caption = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edlxz8s2"
} : 0)( true ? {
  name: "r445y0",
  styles: "max-width:1040px;margin:0 auto;padding:40px 24px 80px 24px"
} : 0);

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "edlxz8s1"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "edlxz8s0"
} : 0)("a{color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.twilio.gray[100];
}, ";}" + ( true ? "" : 0));

/* harmony default export */ var GettingStarted_GettingStarted = (GettingStarted);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ./src/views/Home/components/DataArchitecture/assets/IlloUseCaseActivateCustomerDataDefault.png
var IlloUseCaseActivateCustomerDataDefault = __webpack_require__(85903);
var IlloUseCaseActivateCustomerDataDefault_default = /*#__PURE__*/__webpack_require__.n(IlloUseCaseActivateCustomerDataDefault);
// EXTERNAL MODULE: ./src/views/Home/components/DataArchitecture/assets/IlloUseCaseActivateCustomerDataHover.png
var IlloUseCaseActivateCustomerDataHover = __webpack_require__(81692);
var IlloUseCaseActivateCustomerDataHover_default = /*#__PURE__*/__webpack_require__.n(IlloUseCaseActivateCustomerDataHover);
// EXTERNAL MODULE: ./src/views/Home/components/DataArchitecture/assets/IlloUseCaseBoostCrossSellDefault.png
var IlloUseCaseBoostCrossSellDefault = __webpack_require__(81755);
var IlloUseCaseBoostCrossSellDefault_default = /*#__PURE__*/__webpack_require__.n(IlloUseCaseBoostCrossSellDefault);
// EXTERNAL MODULE: ./src/views/Home/components/DataArchitecture/assets/IlloUseCaseBoostCrossSellHover.png
var IlloUseCaseBoostCrossSellHover = __webpack_require__(75201);
var IlloUseCaseBoostCrossSellHover_default = /*#__PURE__*/__webpack_require__.n(IlloUseCaseBoostCrossSellHover);
// EXTERNAL MODULE: ./src/views/Home/components/DataArchitecture/assets/IlloUseCaseEnrichCustomerProfilesDefault.png
var IlloUseCaseEnrichCustomerProfilesDefault = __webpack_require__(76623);
var IlloUseCaseEnrichCustomerProfilesDefault_default = /*#__PURE__*/__webpack_require__.n(IlloUseCaseEnrichCustomerProfilesDefault);
// EXTERNAL MODULE: ./src/views/Home/components/DataArchitecture/assets/IlloUseCaseEnrichCustomerProfilesHover.png
var IlloUseCaseEnrichCustomerProfilesHover = __webpack_require__(17571);
var IlloUseCaseEnrichCustomerProfilesHover_default = /*#__PURE__*/__webpack_require__.n(IlloUseCaseEnrichCustomerProfilesHover);
// EXTERNAL MODULE: ./src/views/Home/components/DataArchitecture/assets/IlloUseCaseOptimizeAdSpendDefault.png
var IlloUseCaseOptimizeAdSpendDefault = __webpack_require__(89755);
var IlloUseCaseOptimizeAdSpendDefault_default = /*#__PURE__*/__webpack_require__.n(IlloUseCaseOptimizeAdSpendDefault);
// EXTERNAL MODULE: ./src/views/Home/components/DataArchitecture/assets/IlloUseCaseOptimizeAdSpendHover.png
var IlloUseCaseOptimizeAdSpendHover = __webpack_require__(96054);
var IlloUseCaseOptimizeAdSpendHover_default = /*#__PURE__*/__webpack_require__.n(IlloUseCaseOptimizeAdSpendHover);
;// CONCATENATED MODULE: ./src/views/Home/components/DataArchitecture/DataArchitecture.tsx


function DataArchitecture_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





















var DataArchitecture_copy = {
  heading: "with good data"
};
var headings = ["AI", "Personalization", "Compliance", "Advertising", "Scalability", "Segmentation", "ROI", "Everything"];
var cards = [{
  title: "Enrich customer profiles",
  description: "Build and automatically enrich identity-resolved profiles with every new interaction to better predict and provide relevant customer experiences in real time.",
  link: "/use-cases/enrich-customer-profiles/",
  buttonText: "Unify & enrich your data",
  imageDefault: (IlloUseCaseEnrichCustomerProfilesDefault_default()),
  imageHover: (IlloUseCaseEnrichCustomerProfilesHover_default())
}, {
  title: "Activate customer data",
  description: "Our 450+ pre-built connectors make it fast and easy to get all the data you need into unified customer profiles\u2014and activate those profiles to power the tools you use.",
  link: "/use-cases/activate-customer-data/",
  buttonText: "Activate your data",
  imageDefault: (IlloUseCaseActivateCustomerDataDefault_default()),
  imageHover: (IlloUseCaseActivateCustomerDataHover_default())
}, {
  title: "Optimize ad spend",
  description: "Make it easy for marketers to activate first-party data and use AI to build more predictive, precise, and personalized ads that drive conversions and lower customer acquisition costs.",
  link: "/use-cases/optimize-ad-spend/",
  buttonText: "Increase your RoAS",
  imageDefault: (IlloUseCaseOptimizeAdSpendDefault_default()),
  imageHover: (IlloUseCaseOptimizeAdSpendHover_default())
}, {
  title: "Boost cross-sell and upsell",
  description: "Use AI to anticipate customer needs and recommend the right item to the right customers at the best time for conversion to drive repeat sales.",
  link: "/use-cases/boost-cross-sell-upsell/",
  buttonText: "Increase Customer Value",
  imageDefault: (IlloUseCaseBoostCrossSellDefault_default()),
  imageHover: (IlloUseCaseBoostCrossSellHover_default())
}];

var DataArchitecture = function DataArchitecture() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useState = (0,react.useState)(0),
      index = _useState[0],
      setIndex = _useState[1];

  (0,react.useEffect)(function () {
    var id = setInterval(function () {
      setIndex(function (state) {
        if (state >= headings.length - 1) return 0;
        return state + 1;
      });
    }, 2000);
    return function () {
      return clearInterval(id);
    };
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextHeading, {
          tag: "h2",
          variant: "homeH2",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
            initial: false,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RotatingHeadingWrapper, {
              initial: {
                y: 20,
                opacity: 0
              },
              animate: {
                y: 0,
                opacity: 1
              },
              exit: {
                y: -20,
                opacity: 0
              },
              transition: {
                ease: "easeInOut"
              },
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RotatingHeading, {
                children: [headings[index], " is better"]
              })
            }, headings[index])
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaticHeading, {
            children: DataArchitecture_copy.heading
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          md: 2,
          lg: 4
        },
        children: cards.map(function (card) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCardBase, {
            appearance: "twilioLight",
            href: (0,getAbsoluteUrl/* default */.Z)(card.link, pageConfig),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardImageBox, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardImage, {
                alt: "",
                src: card.imageDefault
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverlayingCardImage, {
                alt: "",
                src: card.imageHover
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardHeadline, {
                  variant: "h3",
                  tag: "h3",
                  children: card.title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  children: card.description
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                  tag: "span",
                  size: "medium",
                  iconEnd: Common/* ChevronRightIcon */.XC,
                  children: card.buttonText
                })
              })]
            })]
          }, "".concat(card.title));
        })
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ebwuw7a10"
} : 0)(Section/* Wrapper */.im, "{row-gap:64px;}" + ( true ? "" : 0));

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ebwuw7a9"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var StyledCardHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Headline */.s0,  true ? {
  target: "ebwuw7a8"
} : 0)( true ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : 0);

var StyledCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* default */.ZP,  true ? {
  target: "ebwuw7a7"
} : 0)( true ? "" : 0);

var CardImageBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebwuw7a6"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var CardImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ebwuw7a5"
} : 0)("width:100%;z-index:1;", StyledCardBase, ":hover &{z-index:0;}" + ( true ? "" : 0));

var OverlayingCardImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ebwuw7a4"
} : 0)("width:100%;position:absolute;left:0;top:0;z-index:2;opacity:0;transition:opacity 0.3s ease-in-out;", StyledCardBase, ":hover &{opacity:1;z-index:1;}" + ( true ? "" : 0));

var StyledCopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "ebwuw7a3"
} : 0)( true ? {
  name: "pw7jst",
  styles: "position:relative;width:100%"
} : 0);

var StaticHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ebwuw7a2"
} : 0)("font-weight:400;line-height:1.4;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("sm");
}, "{font-size:28px;}" + ( true ? "" : 0));

var RotatingHeadingWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.span,  true ? {
  target: "ebwuw7a1"
} : 0)( true ? {
  name: "1vax51i",
  styles: "position:absolute;left:0;width:100%"
} : 0);

var RotatingHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ebwuw7a0"
} : 0)("position:relative;&::before{content:'';display:block;position:absolute;left:0;bottom:-5px;height:3px;width:100%;border-bottom:3px dotted ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.green[60];
}, ";}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{font-size:28px;}" + ( true ? "" : 0));

/* harmony default export */ var DataArchitecture_DataArchitecture = (DataArchitecture);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/utils/createIconsComponent.tsx + 1 modules
var createIconsComponent = __webpack_require__(37699);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Twilio/DataIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var DataIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  viewBox: "0 0 29 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.341 6.375a.9.9 0 0 1 .9-.9h8.901a.9.9 0 0 1 0 1.8h-8.9a.9.9 0 0 1-.9-.9Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2v21.017h10.22a2.987 2.987 0 0 1-.438-1.563V3.564c0-.573.16-1.109.439-1.564H2Zm13.651-2a1 1 0 0 1 1 1v.563a1 1 0 0 1-1 1h-.87a1 1 0 0 0-1 1v17.89a1 1 0 0 0 1 1h.87a1 1 0 0 1 1 1v.564a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14.651Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.228 6.375c0-.553.39-1 .87-1h3.676c.48 0 .87.447.87 1 0 .552-.39 1-.87 1H5.098c-.48 0-.87-.448-.87-1ZM4.228 10.526c0-.552.39-1 .87-1h3.676c.48 0 .87.448.87 1s-.39 1-.87 1H5.098c-.48 0-.87-.448-.87-1ZM4.228 14.491c0-.552.39-1 .87-1h3.676c.48 0 .87.448.87 1s-.39 1-.87 1H5.098c-.48 0-.87-.448-.87-1ZM4.228 18.456c0-.552.39-1 .87-1h3.676c.48 0 .87.448.87 1s-.39 1-.87 1H5.098c-.48 0-.87-.448-.87-1Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M28.124 6.375a1.982 1.982 0 1 1-3.964 0 1.982 1.982 0 0 1 3.964 0Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.341 14.491a.9.9 0 0 1 .9-.9h8.901a.9.9 0 1 1 0 1.8h-8.9a.9.9 0 0 1-.9-.9Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M28.125 14.491a1.982 1.982 0 1 1-3.965 0 1.982 1.982 0 0 1 3.965 0Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.342 10.526a.9.9 0 0 1 .9-.9h6.028a.9.9 0 0 1 0 1.8h-6.028a.9.9 0 0 1-.9-.9Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M25.252 10.526a1.982 1.982 0 1 1-3.964 0 1.982 1.982 0 0 1 3.964 0Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.342 18.456a.9.9 0 0 1 .9-.9h6.028a.9.9 0 0 1 0 1.8h-6.028a.9.9 0 0 1-.9-.9Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M25.252 18.456a1.982 1.982 0 1 1-3.964 0 1.982 1.982 0 0 1 3.964 0Z",
    fill: "none"
  })]
}), 'DataIcon', 'Twilio');
/* harmony default export */ var Twilio_DataIcon = (DataIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Twilio/PeopleIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var PeopleIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  viewBox: "0 0 28 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.194 5.353A5.598 5.598 0 0 1 9.078 3.8c1.45 0 2.848.555 3.885 1.554A5.273 5.273 0 0 1 14.59 9.15c0 1.432-.59 2.796-1.627 3.797A5.598 5.598 0 0 1 9.078 14.5a5.598 5.598 0 0 1-3.884-1.554 5.273 5.273 0 0 1-1.628-3.797c0-1.43.59-2.795 1.628-3.796Zm3.884.446c-.943 0-1.84.361-2.496.994a3.273 3.273 0 0 0-1.016 2.356c0 .877.361 1.726 1.016 2.357a3.598 3.598 0 0 0 2.496.994c.943 0 1.84-.361 2.496-.994a3.274 3.274 0 0 0 1.016-2.357c0-.876-.361-1.725-1.016-2.356a3.598 3.598 0 0 0-2.496-.994Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.078 16.082a6.524 6.524 0 0 0-4.526 1.805 5.993 5.993 0 0 0-1.857 4.314 1 1 0 1 1-2 0c0-2.165.893-4.234 2.469-5.754a8.524 8.524 0 0 1 5.914-2.365c2.212 0 4.34.847 5.915 2.365a7.993 7.993 0 0 1 2.468 5.754 1 1 0 1 1-2 0c0-1.61-.663-3.163-1.857-4.314a6.524 6.524 0 0 0-4.526-1.805ZM20.61 6.212a3.648 3.648 0 0 0-3.617.137 1 1 0 0 1-1.062-1.695 5.648 5.648 0 0 1 5.607-.213c.87.456 1.601 1.132 2.112 1.962.512.83.783 1.78.782 2.751 0 .97-.274 1.921-.787 2.75a5.444 5.444 0 0 1-2.115 1.958 5.649 5.649 0 0 1-5.607-.222 1 1 0 1 1 1.065-1.693 3.649 3.649 0 0 0 3.617.142 3.444 3.444 0 0 0 1.34-1.237c.32-.517.486-1.104.487-1.7 0-.596-.166-1.183-.484-1.7a3.443 3.443 0 0 0-1.338-1.24Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.35 16.239a6.658 6.658 0 0 0-2.855-.004 1 1 0 1 1-.427-1.954 8.658 8.658 0 0 1 3.713.005 8.509 8.509 0 0 1 3.353 1.56 8.18 8.18 0 0 1 2.332 2.82c.55 1.101.837 2.31.839 3.534a1 1 0 1 1-2 .002 5.916 5.916 0 0 0-.628-2.64 6.176 6.176 0 0 0-1.763-2.131 6.508 6.508 0 0 0-2.564-1.192Z",
    fill: "none"
  })]
}), 'PeopleIcon', 'Twilio');
/* harmony default export */ var Twilio_PeopleIcon = (PeopleIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Twilio/ProductIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ProductIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.761 2H2v20.49h10.761V2ZM2 0a2 2 0 0 0-2 2v20.49a2 2 0 0 0 2 2h10.761a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2ZM18.761 2.472a1 1 0 0 1 1 1v17.543a1 1 0 1 1-2 0V3.472a1 1 0 0 1 1-1ZM23.761 5.495a1 1 0 0 1 1 1v11.5a1 1 0 1 1-2 0v-11.5a1 1 0 0 1 1-1Z",
    fill: "none"
  })
}), 'ProductIcon', 'Twilio');
/* harmony default export */ var Twilio_ProductIcon = (ProductIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/Twilio.ts
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
;// CONCATENATED MODULE: ./src/views/Home/components/UseCase/UseCase.tsx


function UseCase_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var UseCase_copy = {
  heading: "A CDP that works hard for every team, backed by enterprise-grade infrastructure"
};
var features = [{
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Twilio_DataIcon, {
    size: "medium"
  }),
  title: "Data engineers",
  text: "Segment\u2019s libraries, automatic sources, and functions collect data from anywhere\u2014hundreds of thousands of times per second\u2014so you can move it where you need it.",
  anchorText: "Segment for engineers",
  href: "/engineering/"
}, {
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Twilio_PeopleIcon, {
    size: "medium"
  }),
  title: "Marketers",
  text: "Know your customers through rich profiles and use AI to anticipate their needs and create personalized campaigns that improve ROI.",
  anchorText: "Segment for marketers",
  href: "/marketing/"
}, {
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Twilio_ProductIcon, {
    size: "medium"
  }),
  title: "Product managers",
  text: "Get a complete view of your customers for better personalization, conversion optimization, and predictive recommendations.",
  anchorText: "Segment for product",
  href: "/product/"
}];

var UseCase_DataArchitecture = function DataArchitecture() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UseCase_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "homeH3",
          children: UseCase_copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          lg: 3
        },
        children: features.map(function (feature) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
            alignment: "left",
            headerPosition: "top",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                variant: "circle",
                elevation: 1,
                tokens: {
                  backgroundColor: theme.palette.twilio.mint[100]
                },
                children: feature.icon
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                variant: "homeH4",
                children: feature.title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                variant: "pMedium",
                children: feature.text
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
                size: "medium",
                href: (0,getAbsoluteUrl/* default */.Z)(feature.href, pageConfig),
                iconEnd: Common/* ChevronRightIcon */.XC,
                children: feature.anchorText
              })]
            })]
          }, feature.title);
        })
      })
    })]
  });
};

var UseCase_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e11pgsa41"
} : 0)(Section/* Wrapper */.im, "{padding-bottom:0;row-gap:45px;}" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e11pgsa40"
} : 0)( true ? {
  name: "7fko3c",
  styles: "justify-self:start"
} : 0);

/* harmony default export */ var UseCase = (UseCase_DataArchitecture);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
;// CONCATENATED MODULE: ./src/views/Home/components/Integrations/Integrations.tsx


function Integrations_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var Integrations_copy = {
  heading: "Integrations",
  description: "450+ pre-built integrations that you can enable with the flip of a switch.",
  button: {
    text: "Explore integrations",
    href: "/catalog/"
  }
};

var Integrations = function Integrations() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Integrations_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: "twilioDark",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            variant: "homeH2",
            children: Integrations_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "homePExtraLarge",
            children: Integrations_copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Integrations_ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            size: "large",
            color: "primary",
            variant: "filled",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)("".concat(Integrations_copy.button.href), pageConfig),
            children: Integrations_copy.button.text
          })
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {
      tokens: {
        gradientColor: theme.palette.twilio.gray[100]
      }
    })]
  });
};

var Integrations_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebxnou2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebxnou1"
} : 0)( true ? {
  name: "6o84rx",
  styles: "display:grid;justify-content:center;row-gap:40px;padding:0 20px"
} : 0);

var Integrations_ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebxnou0"
} : 0)("justify-self:center;margin-bottom:30px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{margin-bottom:0;}" + ( true ? "" : 0));

/* harmony default export */ var Integrations_Integrations = (Integrations);
// EXTERNAL MODULE: ./src/views/Home/components/ActivateWarehouseData/assets/WarehouseData@2x.png
var WarehouseData_2x = __webpack_require__(26588);
var WarehouseData_2x_default = /*#__PURE__*/__webpack_require__.n(WarehouseData_2x);
// EXTERNAL MODULE: ./src/views/Home/components/ActivateWarehouseData/assets/WarehouseData.webp
var WarehouseData = __webpack_require__(702);
var WarehouseData_default = /*#__PURE__*/__webpack_require__.n(WarehouseData);
// EXTERNAL MODULE: ./src/views/Home/components/ActivateWarehouseData/assets/WarehouseData@2x.webp
var assets_WarehouseData_2x = __webpack_require__(18501);
var assets_WarehouseData_2x_default = /*#__PURE__*/__webpack_require__.n(assets_WarehouseData_2x);
;// CONCATENATED MODULE: ./src/views/Home/components/ActivateWarehouseData/ActivateWarehouseData.tsx


function ActivateWarehouseData_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var ActivateWarehouseData_copy = {
  heading: "Activate warehouse data with a CDP that\u2019s powerful yet flexible",
  description: "Twilio Segment makes it easy for data teams to prepare, enrich, and activate existing data in the warehouse, so marketers can move fast with personalized communication.",
  button: {
    text: "Explore Reverse ETL",
    href: "/product/reverse-etl/"
  },
  buttonText: {
    text: "View docs",
    href: "https://segment.com/docs/"
  }
};
var stats = [{
  heading: "#1 CDP",
  description: "in 2022 market share per IDC*"
}, {
  heading: "12,696",
  description: "unique events tracked**"
}, {
  heading: "12.1 Trillion",
  description: "API calls processed in 2023**"
}];
var data = [{
  heading: "Keep your data where it is",
  description: "With a zero copy architecture that treats the warehouse as a source of truth, you can make event streams, product information, and entity data open to any team and application."
}, {
  heading: "Get extensibility without complexity",
  description: "Build, deploy, and scale on a platform that easily integrates with your tech stack so you can quickly adapt to changing customer needs while maintaining data privacy."
}, {
  heading: "Enhance every experience with warehouse data",
  description: "Enrich and unlock customer profiles across your organization with real-time data and predictive AI to make every customer interaction more impactful."
}];

var ActivateWarehouseData = function ActivateWarehouseData() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActivateWarehouseData_StyledSection, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "homeH2",
          children: ActivateWarehouseData_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "homePExtraLarge",
          children: ActivateWarehouseData_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          lg: 3
        },
        children: stats.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Header */.h4, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                variant: "homeH2",
                children: item.heading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                variant: "pMedium",
                children: item.description
              })]
            })
          }, item.heading);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((WarehouseData_default()), ", ").concat((assets_WarehouseData_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivateWarehouseData_StyledImage, {
            src: (WarehouseData_2x_default()),
            alt: "Warehouse Data",
            width: "733",
            height: "733",
            loading: "lazy"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivateWarehouseData_Copy, {
          children: data.map(function (item) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
              alignment: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  variant: "homeH5",
                  tag: "h3",
                  children: item.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  variant: "pMedium",
                  tag: "p",
                  children: item.description
                })]
              })
            }, item.heading);
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActivateWarehouseData_ButtonsWrapper, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          href: (0,getAbsoluteUrl/* default */.Z)(ActivateWarehouseData_copy.button.href, pageConfig),
          children: ActivateWarehouseData_copy.button.text
        }, ActivateWarehouseData_copy.button.text), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          href: (0,getAbsoluteUrl/* default */.Z)(ActivateWarehouseData_copy.buttonText.href, pageConfig),
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: ActivateWarehouseData_copy.buttonText.text
        }, ActivateWarehouseData_copy.buttonText.text)]
      })]
    })]
  });
};

var ActivateWarehouseData_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e7hme6n4"
} : 0)(Section/* Wrapper */.im, "{", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{gap:40px;}}" + ( true ? "" : 0));

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7hme6n3"
} : 0)("margin:60px 0;display:grid;gap:80px;grid-auto-flow:column;align-items:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{grid-auto-flow:row;gap:40px;}" + ( true ? "" : 0));

var ActivateWarehouseData_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e7hme6n2"
} : 0)("width:100%;max-width:490px;filter:drop-shadow(", function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

var ActivateWarehouseData_Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7hme6n1"
} : 0)("display:flex;flex-direction:column;gap:60px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("lg");
}, "{gap:40px;}" + ( true ? "" : 0));

var ActivateWarehouseData_ButtonsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7hme6n0"
} : 0)( true ? {
  name: "f4cpc",
  styles: "display:flex;gap:24px;justify-content:center;align-items:center"
} : 0);

/* harmony default export */ var ActivateWarehouseData_ActivateWarehouseData = (ActivateWarehouseData);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TabsLayout/index.ts + 1 modules
var TabsLayout = __webpack_require__(82274);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Tabs/useTabs/index.ts + 1 modules
var useTabs = __webpack_require__(53834);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/AIReadyData@2x.png
var AIReadyData_2x = __webpack_require__(59855);
var AIReadyData_2x_default = /*#__PURE__*/__webpack_require__.n(AIReadyData_2x);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/AIReadyData.webp
var AIReadyData = __webpack_require__(92439);
var AIReadyData_default = /*#__PURE__*/__webpack_require__.n(AIReadyData);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/AIReadyData@2x.webp
var assets_AIReadyData_2x = __webpack_require__(8681);
var assets_AIReadyData_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AIReadyData_2x);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/GenerativeAI@2x.png
var GenerativeAI_2x = __webpack_require__(50598);
var GenerativeAI_2x_default = /*#__PURE__*/__webpack_require__.n(GenerativeAI_2x);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/GenerativeAI.webp
var GenerativeAI = __webpack_require__(1318);
var GenerativeAI_default = /*#__PURE__*/__webpack_require__.n(GenerativeAI);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/GenerativeAI@2x.webp
var assets_GenerativeAI_2x = __webpack_require__(47642);
var assets_GenerativeAI_2x_default = /*#__PURE__*/__webpack_require__.n(assets_GenerativeAI_2x);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/PredictiveAI@2x.png
var PredictiveAI_2x = __webpack_require__(15020);
var PredictiveAI_2x_default = /*#__PURE__*/__webpack_require__.n(PredictiveAI_2x);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/PredictiveAI.webp
var PredictiveAI = __webpack_require__(88294);
var PredictiveAI_default = /*#__PURE__*/__webpack_require__.n(PredictiveAI);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/PredictiveAI@2x.webp
var assets_PredictiveAI_2x = __webpack_require__(40277);
var assets_PredictiveAI_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PredictiveAI_2x);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/SecurityAndPrivacy@2x.png
var SecurityAndPrivacy_2x = __webpack_require__(8010);
var SecurityAndPrivacy_2x_default = /*#__PURE__*/__webpack_require__.n(SecurityAndPrivacy_2x);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/SecurityAndPrivacy.webp
var SecurityAndPrivacy = __webpack_require__(94401);
var SecurityAndPrivacy_default = /*#__PURE__*/__webpack_require__.n(SecurityAndPrivacy);
// EXTERNAL MODULE: ./src/views/Home/components/Interactions/assets/SecurityAndPrivacy@2x.webp
var assets_SecurityAndPrivacy_2x = __webpack_require__(52375);
var assets_SecurityAndPrivacy_2x_default = /*#__PURE__*/__webpack_require__.n(assets_SecurityAndPrivacy_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./src/views/Home/components/Interactions/Interactions.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Interactions_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



























var Interactions_copy = {
  heading: "Provide 1:1 interactions at scale with CustomerAI"
};
var tabs = [{
  key: "generative-ai",
  badge: "Beta",
  heading: "Generative AI",
  description: "Create targeted audiences and launch personalized customer journeys within minutes using simple text prompts.",
  link: {
    text: "Explore CustomerAI",
    url: "/solutions/ai"
  },
  image: {
    png2x: (GenerativeAI_2x_default()),
    webp: (GenerativeAI_default()),
    webp2x: (assets_GenerativeAI_2x_default()),
    width: 720,
    height: 720
  }
}, {
  key: "predictive-ai",
  heading: "Predictive AI",
  description: "Predict customer behavior to build targeted audiences and more personalized campaigns that lower costs and increase conversions.",
  link: {
    text: "Explore CustomerAI Predictions",
    url: "/solutions/ai/customerai-predictions/"
  },
  image: {
    dropShadow: true,
    png2x: (PredictiveAI_2x_default()),
    webp: (PredictiveAI_default()),
    webp2x: (assets_PredictiveAI_2x_default()),
    width: 721,
    height: 721
  }
}, {
  key: "ai-ready-data",
  heading: "AI-ready data",
  description: "Your AI outputs are only as good as the data you put in. Start with clean data, centralized privacy, and governance to get accurate recommendations and predictions.",
  link: {
    text: "Explore CustomerAI",
    url: "/solutions/ai/"
  },
  image: {
    dropShadow: true,
    png2x: (AIReadyData_2x_default()),
    webp: (AIReadyData_default()),
    webp2x: (assets_AIReadyData_2x_default()),
    width: 721,
    height: 721
  }
}, {
  key: "security-and-privacy",
  heading: "Security and privacy",
  description: "We promote the ethical and responsible use of data privacy with AI. With all Segment products, you have full visibility into and control over the personal information you collect from customers so you can protect it and meet privacy requirements.",
  link: {
    text: "See our privacy portal",
    url: "/product/privacy-portal/"
  },
  image: {
    dropShadow: true,
    png2x: (SecurityAndPrivacy_2x_default()),
    webp: (SecurityAndPrivacy_default()),
    webp2x: (assets_SecurityAndPrivacy_2x_default()),
    width: 721,
    height: 721
  }
}];

var Interactions = function Interactions() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useTabs = (0,useTabs/* default */.Z)(0, tabs.length, "interactions"),
      getTrackProps = _useTabs.getTrackProps,
      getControlProps = _useTabs.getControlProps,
      getPanelProps = _useTabs.getPanelProps,
      activeTabKey = _useTabs.activeTabKey;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Interactions_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Interactions_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          centered: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            variant: "homeH2",
            children: Interactions_copy.heading
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabsLayout/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Controls */.ZX, _objectSpread(_objectSpread({
            tokens: {
              backgroundColor: theme.palette.twilio.mint[20]
            }
          }, getTrackProps()), {}, {
            children: tabs.map(function (tab, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Control */.oT, _objectSpread(_objectSpread({
                tokens: {
                  root: {
                    color: theme.palette.twilio.gray[100],
                    hoverColor: theme.palette.twilio.gray[100],
                    outlineColor: theme.palette.twilio.gray[100]
                  }
                }
              }, getControlProps(index)), {}, {
                children: tab.heading
              }), tab.key);
            })
          })), tabs.map(function (tab, index) {
            return (0,emotion_react_browser_esm/* createElement */.az)(TabsLayout/* Content */.VY, _objectSpread(_objectSpread({}, getPanelProps(index)), {}, {
              active: index === activeTabKey,
              key: tab.heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Copy */.CK, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
                children: [tab.badge && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                  variant: "textRegularSmall",
                  children: tab.badge
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                  variant: "homeH4",
                  children: tab.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                  variant: "pMedium",
                  children: tab.description
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Interactions_ButtonWrapper, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                    size: "large",
                    variant: "filled",
                    color: "primary",
                    href: (0,getAbsoluteUrl/* default */.Z)(tab.link.url, pageConfig),
                    children: tab.link.text
                  })
                })]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Media */.pU, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                  type: "image/webp",
                  srcSet: "".concat(tab.image.webp, ", ").concat(tab.image.webp2x, " 2x")
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Interactions_StyledImage, {
                  alt: tab.heading,
                  width: tab.image.width,
                  height: tab.image.height,
                  src: tab.image.png2x,
                  loading: "lazy"
                })]
              })
            }));
          })]
        })
      })]
    })
  });
};

var Interactions_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ew2d7204"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.mint[10];
}, ";" + ( true ? "" : 0));

var Interactions_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ew2d7203"
} : 0)(Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{gap:40px;}}" + ( true ? "" : 0));

var Interactions_StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "ew2d7202"
} : 0)("width:100%;max-width:490px;filter:drop-shadow(", function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

var Interactions_ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ew2d7201"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var Badge = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ew2d7200"
} : 0)("display:inline-block;padding:4px 16px;border:1px solid ", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.twilio.gray[100];
}, ";border-radius:24px;margin:0;" + ( true ? "" : 0));

/* harmony default export */ var Interactions_Interactions = (Interactions);
// EXTERNAL MODULE: ./src/views/Home/assets/OgHome.png
var OgHome = __webpack_require__(32077);
var OgHome_default = /*#__PURE__*/__webpack_require__.n(OgHome);
;// CONCATENATED MODULE: ./src/views/Home/Home.tsx



function Home_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Home_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Home_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Home_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var LogoCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5062), __webpack_require__.e(1620)]).then(__webpack_require__.bind(__webpack_require__, 6087));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6087)];
    }
  }
});
var announcementsCopy = {
  announcement: {
    description: "Join us on July 24th to learn how The Motley Fool is using AI to Unlock the Future of CX",
    ctaTitle: "Register now",
    ctaLink: "https://webinars.segment.com/segment/cdp-live-unlock-future-of-customer-experiences?utm_source=homepage-banner&utm_medium=referral&utm_campaign=all_ic_2024-07-24-wbnr-cdp-live_20240724&utm_content=webinar "
  },
  mobileAnnouncement: {
    description: "Unlock the Future of Customer Experiences with AI",
    ctaTitle: "Register now",
    ctaLink: "https://webinars.segment.com/segment/cdp-live-unlock-future-of-customer-experiences?utm_source=homepage-banner&utm_medium=referral&utm_campaign=all_ic_2024-07-24-wbnr-cdp-live_20240724&utm_content=webinar "
  }
};

var HomeView = function HomeView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Twilio Segment - Ranked #1 Customer Data Platform four years in a row per IDC (2019-2022)",
      pageDescription: "Twilio Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data.",
      pageOG: (OgHome_default()),
      themeColor: theme.palette.brand.darkAcai[700],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, Home_objectSpread({}, announcementsCopy)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
        appearance: "twilioDark"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataArchitecture_DataArchitecture, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseCase, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarouselWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Interactions_Interactions, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivateWarehouseData_ActivateWarehouseData, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Integrations_Integrations, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialsSlider_TestimonialsSlider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TheGrowthReport_TheGrowthReport, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_GettingStarted, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1g2eyd91"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var LogoCarouselWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g2eyd90"
} : 0)("padding-top:24px;padding-bottom:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding:64px 0;}" + ( true ? "" : 0));

/* harmony default export */ var Home_Home = (HomeView);
;// CONCATENATED MODULE: ./src/pages/index.tsx



var Home = function Home() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Home_Home, {});
};

/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 96856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useLocation_useLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/location.ts



var fetchLocation = function fetchLocation(client, signal) {
  return client.get("/location/", {
    signal: signal,
    headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
  });
};

var fetchLocationCode = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, signal) {
    var code;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/location/countryCode/", {
              signal: signal,
              headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
            });

          case 2:
            code = _context.sent;
            return _context.abrupt("return", code.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLocationCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/useLocation.ts





/**
 * A hook that provides the country code of the user's location.
 * @returns The country code of the user's location.
 */

var useLocation = function useLocation() {
  var _useState = (0,react.useState)(""),
      code = _useState[0],
      setCode = _useState[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocationCode((0,client/* createClient */.e)(), signal);

            case 3:
              response = _context.sent;
              setCode(response.toLowerCase());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setCode("us");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react.useEffect)(function () {
    var controller = new AbortController();
    fetchData(controller.signal);
    return function () {
      controller.abort();
    };
  }, [fetchData]);
  return code;
};

/* harmony default export */ var useLocation_useLocation = (useLocation);
;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/index.ts


/***/ }),

/***/ 805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DemoProvider; },
/* harmony export */   "d": function() { return /* binding */ DemoContext; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DemoContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  completedFormData: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCompletedFormData: function setCompletedFormData() {}
});
var DemoProvider = function DemoProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    completedFormData: undefined,
    setCompletedFormData: function setCompletedFormData(value) {
      return setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          completedFormData: value
        });
      });
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DemoContext.Provider, {
    value: state,
    children: children
  });
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_IconWrapper_IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bo4d8j1"
} : 0)("width:44px;height:44px;border-radius:50%;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";", function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1iixa1j",
  styles: "width:40px;height:40px;svg{width:40px;height:40px;}padding:2px"
} : 0;

var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1bo4d8j0"
} : 0)("display:block;width:24px;height:24px;padding:10px;", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "transparent" && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.tsx


var _excluded = ["tokens", "variant", "elevation", "className", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseIconWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      variant = _ref.variant,
      elevation = _ref.elevation,
      className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className,
    elevation: elevation,
    as: tag
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      variant: variant,
      children: children
    })
  }));
});

var getBackgroundPropTokens = function getBackgroundPropTokens(background, theme) {
  switch (background) {
    case "white":
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[500]
      };

    case "light":
      return {
        backgroundColor: theme.palette.brand.boysenberry[100],
        color: theme.palette.brand.darkAcai[700]
      };

    case "dark":
      return {
        backgroundColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.brand.boysenberry[200]
      };

    default:
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
  }
};

var IconWrapper_IconWrapper = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIconWrapper, function (_ref2) {
  var elevation = _ref2.elevation;
  return {
    elevation: elevation
  };
}, {
  light: function light(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.darkAcai[700],
      backgroundColor: theme.palette.brand.boysenberry[100]
    };
  },
  dark: function dark(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.neutrals.white[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.boysenberry[200],
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.twilio.gray[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.twilio.gray[100],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
/* harmony default export */ var components_IconWrapper_IconWrapper = (IconWrapper_IconWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 82274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VY": function() { return /* reexport */ Content; },
  "oT": function() { return /* reexport */ Control; },
  "ZX": function() { return /* reexport */ Controls; },
  "CK": function() { return /* reexport */ Copy; },
  "pU": function() { return /* reexport */ Media; },
  "ZP": function() { return /* reexport */ TabsLayout_TabsLayout; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Tabs/index.ts + 12 modules
var Tabs = __webpack_require__(15347);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TabsLayout/TabsLayout.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tabs/* Panel */.s_,  true ? {
  target: "e14nbdi65"
} : 0)("grid-area:content;display:grid;gap:80px;grid-template-areas:'copy media';justify-content:center;justify-items:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("sm");
}, "{gap:40px;grid-template-areas:'copy' 'media';}" + ( true ? "" : 0));
var TabsLayout = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14nbdi64"
} : 0)("display:grid;grid-template-areas:'controls' 'content';gap:56px;justify-content:center;justify-items:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("sm");
}, "{gap:40px;}", function (_ref3) {
  var reverse = _ref3.reverse,
      theme = _ref3.theme;
  return reverse && "\n    ".concat(Content, " {\n      grid-template-areas:\n      'media copy';\n\n      ").concat(theme.breakpoints.down("sm"), " {\n        gap: 40px;\n        grid-template-areas:\n          'copy'\n          'media';\n      }\n    }\n  ");
}, ";" + ( true ? "" : 0));
var Controls = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tabs/* Track */.fQ,  true ? {
  target: "e14nbdi63"
} : 0)( true ? {
  name: "17k349u",
  styles: "grid-area:controls"
} : 0);
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14nbdi62"
} : 0)("grid-area:copy;display:grid;grid-template-columns:1fr;align-items:center;", function (_ref4) {
  var align = _ref4.align;
  return align === "start" && "\n    align-self: start;\n  ";
}, " ", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("md");
}, "{max-width:420px;}" + ( true ? "" : 0));
var Media = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14nbdi61"
} : 0)("grid-area:media;display:grid;grid-template-columns:1fr;align-items:center;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("md");
}, "{max-width:600px;}" + ( true ? "" : 0));
var Control = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tabs/* Control */.oT,  true ? {
  target: "e14nbdi60"
} : 0)( true ? "" : 0);
/* harmony default export */ var TabsLayout_TabsLayout = (TabsLayout);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TabsLayout/index.ts

TabsLayout.displayName = "TabsLayoutBase";
Copy.displayName = "TabsLayout.Copy";
Controls.displayName = "TabsLayout.Controls";
Media.displayName = "TabsLayout.Media";
Content.displayName = "TabsLayout.Content";
Control.displayName = "TabsLayout.Control";


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 77840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FormSubmitMessage; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/data.tsx
var data = {
  success: {
    demo: {
      description: "Thank you for submitting your request for a demo! Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment."
    }
  },
  error: {
    demo: {
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq3"
} : 0)("padding:32px;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq2"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq1"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq0"
} : 0)( true ? {
  name: "7ut0hf",
  styles: "margin:0;margin-bottom:16px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx


var _excluded = ["form", "status", "heading", "description", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseFormSubmitMessage = function BaseFormSubmitMessage(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens.wrapper), rest), {}, {
      children: [heading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      })]
    }))
  });
};

var FormSubmitMessage = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitMessage, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  }
});
/* harmony default export */ var FormSubmitMessage_FormSubmitMessage = ((/* unused pure expression or super */ null && (FormSubmitMessage)));

/***/ }),

/***/ 98960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DemoForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/api/utils/useLocation/index.ts + 2 modules
var useLocation = __webpack_require__(96856);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
;// CONCATENATED MODULE: ../../libs/utils/regexes/forbiddenEmail.ts
var customDomainList = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@aol.com", "@hotmail.co.uk", "@hotmail.fr", "@msn.com", "@yahoo.fr", "@wanadoo.fr", "@orange.fr", "@comcast.net", "@yahoo.co.uk", "@yahoo.com.br", "@yahoo.co.in", "@live.com", "@rediffmail.com", "@free.fr", "@gmx.de", "@web.de", "@yandex.ru", "@ymail.com", "@libero.it", "@outlook.com", "@uol.com.br", "@bol.com.br", "@mail.ru", "@cox.net", "@hotmail.it", "@sbcglobal.net", "@sfr.fr", "@live.fr", "@verizon.net", "@live.co.uk", "@googlemail.com", "@yahoo.es", "@ig.com.br", "@live.nl", "@bigpond.com", "@terra.com.br", "@yahoo.it", "@neuf.fr", "@yahoo.de", "@alice.it", "@rocketmail.com", "@att.net", "@laposte.net", "@facebook.com", "@bellsouth.net", "@yahoo.in", "@hotmail.es", "@charter.net", "@yahoo.ca", "@yahoo.com.au", "@rambler.ru", "@hotmail.de", "@tiscali.it", "@shaw.ca", "@yahoo.co.jp", "@sky.com", "@earthlink.net", "@optonline.net", "@freenet.de", "@t-online.de", "@aliceadsl.fr", "@virgilio.it", "@home.nl", "@qq.com", "@telenet.be", "@me.com", "@yahoo.com.ar", "@tiscali.co.uk", "@yahoo.com.mx", "@voila.fr", "@gmx.net", "@mail.com", "@planet.nl", "@tin.it", "@live.it", "@ntlworld.com", "@arcor.de", "@yahoo.co.id", "@frontiernet.net", "@hetnet.nl", "@live.com.au", "@yahoo.com.sg", "@zonnet.nl", "@club-internet.fr", "@juno.com", "@optusnet.com.au", "@blueyonder.co.uk", "@bluewin.ch", "@skynet.be", "@sympatico.ca", "@windstream.net", "@mac.com", "@centurytel.net", "@chello.nl", "@live.ca", "@aim.com", "@bigpond.net.au", "@email.com", "@gmail", "@yahoo", "@hotmail", "@outlook", "@protonmail", "@gwk.com", "@free.", "@tutanota", "@gmx", "@mail2world", "@icloud", "@segment.com", "@.om", "@163.com", "@qq", "@gmai.com", "@yaoo.com", "@company.com", "@gail.com", "@abc.com", "@domain.com", "@gma.com", "@gnail.com", "@li.com", "@yah.com", "@5euros.com", "@business.com", "@emil.com", "@gaylord.info", "@gimal.com", "@gml.com", "@info.com", "@mailinator.com", "@w.com", "@yhoo.com", "@yo.com", "@0546876.com", "@10.com", "@101.gmail.com", "@11.com", "@12356gmail.com", "@123yahoo.com", "@175gmali.com", "@1servicesteamfrazier.com", "@2gmail.com", "@2ncad.com", "@365gmial.com", "@37.com", "@5024gmail.com", "@70gmail.com", "@72gmail.co.com", "@81gmail.com", "@8543g.mail.com", "@9085.gmail.com", "@9784.com", "@asdf.com", "@asdfas222334.com", "@asdsad.com", "@fuckyou.com", "@g.com", "@g.email", "@gamill.com", "@gimel.com", "@gl.com", "@gmaiil.com", "@gmaik.com", "@gmail-elif.com", "@gmail.com.pk", "@gmail.com120194", "@gmail.com4", "@gmaile.com", "@gmaill.com", "@gmaiol.com", "@gmaqil.com", "@gmaul.com", "@gmeel.come", "@gmil.comraj", "@gmsil.com", "@gmw.ere", "@gnail.con", "@haha.com", "@hahaha.com", "@il.co", "@il.com", "@test.cc", "@us.army.mil", "@ya.com", "@yaahoo.com", "@yahoo.coin", "@yho.com", "@yohoo.com", "@.aim", "@zoho", "@protonmail.com", "@mailinator", "@boutique1.com", "@bugfoo.com", "@duiter.com", "@fectode.com", "@gmial.com", "@jewelry.com", "@jims.net", "@jthoven.com", "@lolcorporate.com", "@naver.com", "@restaurant.com", "@stayclearbeauty.com", "@tem.com.my", "@thegymgroup.com", "@Marco.com"]; // Escape the dots in the domains, as they have a special meaning in regex

var escapedDomains = customDomainList.map(function (domain) {
  return domain.replace(/\./g, "\\.");
}); // Create the regex pattern using negative lookahead

var REGEX_PATTERN = "^(?!.*(".concat(escapedDomains.join("|"), ")).*$");
var forbiddenEmailRegex = new RegExp(REGEX_PATTERN, "i"); // Use the 'i' flag for case-insensitive matching

/* harmony default export */ var forbiddenEmail = (forbiddenEmailRegex);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.views.tsx

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc2"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc1"
} : 0)( true ? "" : 0);
var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.tsx


var _excluded = ["appearance", "className", "before", "after", "isProgressive", "isLeadEnrichmentFormEnabled", "overrideConsent", "customFormIdentifier", "customTrackingType", "successMessageAppearance", "onEmailCompleted", "buttonText", "customDisclaimer", "driftCampaignId", "successMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/* eslint-disable react-hooks/exhaustive-deps */





























var MOBILE_OFFSET = -150;
var DESKTOP_OFFSET = -350;
var FORM_ID = "demo-form"; // Set up demo form props since we define some of these props here in the template

var DemoForm = function DemoForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$isProgressive = _ref.isProgressive,
      isProgressive = _ref$isProgressive === void 0 ? false : _ref$isProgressive,
      _ref$isLeadEnrichment = _ref.isLeadEnrichmentFormEnabled,
      isLeadEnrichmentFormEnabled = _ref$isLeadEnrichment === void 0 ? true : _ref$isLeadEnrichment,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      successMessageAppearance = _ref.successMessageAppearance,
      onEmailCompleted = _ref.onEmailCompleted,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Get a demo" : _ref$buttonText,
      customDisclaimer = _ref.customDisclaimer,
      driftCampaignId = _ref.driftCampaignId,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var countryCode = (0,useLocation/* default */.Z)(); // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality

  var _useState = (0,react.useState)(false),
      emailCompleted = _useState[0],
      setEmailCompleted = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      intPhoneErrorCode = _useState2[0],
      setIntPhoneErrorCode = _useState2[1];

  var _useState3 = (0,react.useState)(),
      submittedEmail = _useState3[0],
      setSubmittedEmail = _useState3[1];
  /* eslint-disable camelcase */


  var schema = (0,react.useMemo)(function () {
    var _z$object;

    return lib/* object */.Ry((_z$object = {
      email: lib/* string */.Z_({
        required_error: FormFields/* companyEmailMessages.required */.BN.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(email/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      })
      /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
      .regex(sharedEmail/* default */.C, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(forbiddenEmail, {
        message: FormFields/* companyEmailMessages.forbiddenEmail */.BN.forbiddenEmail
      }),
      name: lib/* string */.Z_({
        required_error: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }).regex(lastName/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      phone: lib/* string */.Z_({
        invalid_type_error: FormFields/* phoneNumberMessages.invalid */.NJ.invalid
      }).min(1, FormFields/* phoneNumberMessages.required */.NJ.required).refine(function () {
        return intPhoneErrorCode === undefined;
      }, {
        message: (0,FormFields/* getPhoneErrorMessage */.AP)(intPhoneErrorCode)
      })
    }, (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_VALID_FIELD */.tj, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_ERRORS_FIELD */.q5, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_CALLING_COUNTRY_CODE */.iZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_COUNTRY_CODE */.$l, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NUMBER */.SZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NATIONAL_FORMAT */.UN, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, "company", lib/* string */.Z_({
      required_error: FormFields/* companyNameMessages.required */.qx.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyNameMessages.invalid */.qx.invalid
    })), _z$object));
  }, [intPhoneErrorCode]);
  /* eslint-enable camelcase */

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  }); // Watch for personal email

  var watchedEmail = methods === null || methods === void 0 ? void 0 : methods.watch("email", ""); // If this is the progressive version of the form, set up email watching
  // Otherwise just always return true

  var showProgressiveFields = isProgressive ? Boolean(watchedEmail || emailCompleted) : true; // Mobile breakpoints

  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  (0,react.useEffect)(function () {
    if (watchedEmail) {
      setEmailCompleted(true);
      if (onEmailCompleted) onEmailCompleted();
    }
  }, [watchedEmail]);
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };

  var collectDriftFormData = function collectDriftFormData(formData) {
    var unTypedWindow = window;

    if (unTypedWindow.drift) {
      unTypedWindow.drift.api.collectFormData(_objectSpread(_objectSpread({}, formData), {}, {
        firstName: formData.name.split(" ")[0],
        lastName: formData.name.split(" ").slice(1).join(" ")
      }), {
        campaignId: driftCampaignId
      });
    }
  };

  (0,react.useEffect)(function () {
    if (methods.getValues("phone")) {
      methods.trigger("phone");
    }
  }, [intPhoneErrorCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: isLeadEnrichmentFormEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message"
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "error",
          "data-hook": "demo-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: function onSubmit(data) {
          setSubmittedEmail(data.email);
          (0,helpers/* createDemoLead */.Ii)(data);

          if (driftCampaignId) {
            collectDriftFormData(data);
          }

          if (isSmallResolution && showProgressiveFields) {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, MOBILE_OFFSET, false);
          } else {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, DESKTOP_OFFSET, false);
          }
        },
        onFailure: helpers/* trackValidationErrorDemoForm */.nR,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onBlur: helpers/* trackValidationErrorDemoForm */.nR
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PhoneNumberField */.g8, {
            countryCode: countryCode,
            onValidate: setIntPhoneErrorCode,
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyNameField */.wA, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          })]
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: buttonText
          })
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer,
            appearance: successMessageAppearance
          })
        })]
      }))
    }), isLeadEnrichmentFormEnabled && methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
      before: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, {
        status: "success",
        form: "demo"
      }),
      email: submittedEmail,
      successMessage: successMessage
    })]
  });
};
/* harmony default export */ var DemoForm_DemoForm = ((/* unused pure expression or super */ null && (DemoForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/index.ts


/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProgressiveProfileForm; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/HiddenEmail.tsx


var _excluded = ["type", "name", "id", "className", "dataHook", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * Email hidden input for demo forms
 */

var HiddenEmailField = function HiddenEmailField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
    "data-testid": "email",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx



var ProgressiveProfileForm_excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "successMessageAppearance", "email", "successMessage"];


function ProgressiveProfileForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProgressiveProfileForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ProgressiveProfileForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProgressiveProfileForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
























var BUTTON_TEXT = "Let's get started";
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  jobTitle: lib/* string */.Z_({
    required_error: JobTitle/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: JobTitle/* jobTitleMessages.invalid */.cY.invalid
  }),
  companySize: lib/* string */.Z_({
    required_error: CompanySize/* companySizeMessages.required */.CF.required
  }),
  monthlyTraffic: lib/* string */.Z_({
    required_error: MonthlyTraffic/* monthlyTrafficMessages.required */.dn.required
  }),
  timeline: lib/* string */.Z_({
    required_error: Timeline/* timelineMessages.required */.Cb.required
  }),
  email: lib/* string */.Z_().optional()
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var ProgressiveProfileForm = function ProgressiveProfileForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      successMessageAppearance = _ref.successMessageAppearance,
      email = _ref.email,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProgressiveProfileForm_excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("progressive-profile-form", -200);

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      setCompletedFormData = _useContext.setCompletedFormData; // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality


  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "progressive-profile-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, ProgressiveProfileForm_objectSpread(ProgressiveProfileForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message",
          onButtonClick: function onButtonClick() {
            (0,helpers/* trackButtonClick */.kO)({
              buttonText: successMessage.buttonText,
              buttonId: "Workspace signup",
              targetUrl: successMessage.buttonUrl
            });
          }
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          status: "error"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setCompletedFormData(data);
                    _context.next = 3;
                    return (0,helpers/* trackProgressiveProfileForm */.NX)(data);

                  case 3:
                    scrollTo();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onFailure: helpers/* trackValidationErrorProgressiveProfileForm */.An,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobTitle/* JobTitleField */.kL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySize/* CompanySizeSelectField */.BQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MonthlyTraffic/* MonthlyTrafficSelectField */.VW, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Timeline/* TimelineSelectField */.fz, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), email && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenEmailField, {
          value: email
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: BUTTON_TEXT
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};
/* harmony default export */ var ProgressiveProfileForm_ProgressiveProfileForm = ((/* unused pure expression or super */ null && (ProgressiveProfileForm)));

/***/ }),

/***/ 2432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ TilesGrid; },
/* harmony export */   "W": function() { return /* binding */ TilesGridWrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13102);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);



var TilesGridWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eazx9zv1"
} : 0)("position:relative;width:100%;max-width:900px;height:320px;margin:0 auto;padding:80px 0 80px;overflow:hidden;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{max-width:1200px;height:385px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:1480px;}&::before,&::after{content:'';display:block;width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;pointer-events:none;}&::before{", function (_ref3) {
  var gradientColor = _ref3.gradientColor;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("background:linear-gradient(90deg, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 35%),linear-gradient(0, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 50%);" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, ";}&::after{", function (_ref4) {
  var gradientColor = _ref4.gradientColor;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("background:linear-gradient(-90deg, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 35%);" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, ";}" + ( true ? "" : 0));
var TilesGrid = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eazx9zv0"
} : 0)("position:absolute;top:50%;left:50%;z-index:0;transform:translate(-50%, -50%);width:900px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("sm");
}, "{width:1200px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{width:1480px;}" + ( true ? "" : 0));

/***/ }),

/***/ 20442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LogoTiles; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/useInView/index.ts + 1 modules
var useInView = __webpack_require__(85807);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/LogoTiles.views.tsx
var LogoTiles_views = __webpack_require__(2432);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoTiles/LogoTiles.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var LogoGrid = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5922), __webpack_require__.e(5838)]).then(__webpack_require__.bind(__webpack_require__, 75838));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(75838)];
    }
  }
});

var BaseLogoTiles = function BaseLogoTiles(_ref) {
  var tokens = _ref.tokens;
  var wrapperRef = (0,react.useRef)(null);
  var isInView = (0,useInView/* default */.Z)(wrapperRef, {
    options: {
      rootMargin: "200px"
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles_views/* TilesGridWrapper */.W, _objectSpread(_objectSpread({}, tokens), {}, {
    ref: wrapperRef,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles_views/* TilesGrid */.$, {
      children: isInView && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoGrid, {})
    })
  }));
};

var LogoTiles = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLogoTiles, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      gradientColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      gradientColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      gradientColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/LogoTiles/index.ts


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 73849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12039);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lottie_web__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



/**
 * A hook that provides an animation instance and a ref to the container element.
 * @param options The options to configure the animation.
 * @returns The animation instance and a ref to the container element.
 */

var useLottie = function useLottie(_ref) {
  var options = _ref.options;
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      animationInstance = _useState[0],
      setAnimationInstance = _useState[1];

  var initializedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!containerRef || !options.animationData || initializedRef.current) {
      return;
    }

    initializedRef.current = true;
    options.animationData.then(function (response) {
      return typeof response.json === "function" ? response.json() : response;
    }).then(function (data) {
      setAnimationInstance(lottie_web__WEBPACK_IMPORTED_MODULE_2___default().loadAnimation(_objectSpread(_objectSpread({
        container: containerRef.current
      }, options), {}, {
        animationData: data
      })));
    });
    return function () {
      return animationInstance === null || animationInstance === void 0 ? void 0 : animationInstance.destroy();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, options.animationData]);
  return [animationInstance, containerRef];
};

/* harmony default export */ __webpack_exports__["Z"] = (useLottie);

/***/ }),

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(82776);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32077:
/***/ (function(module) {

module.exports = "/_next/static/images/OgHome-470ccd9554a990c639ff23e47ef287e6.png";

/***/ }),

/***/ 26588:
/***/ (function(module) {

module.exports = "/_next/static/images/WarehouseData@2x-c738effa51b895675d1a35257f23c940.png";

/***/ }),

/***/ 85903:
/***/ (function(module) {

module.exports = "/_next/static/images/IlloUseCaseActivateCustomerDataDefault-f60f6633290dddf4a126645b44cba894.png";

/***/ }),

/***/ 81692:
/***/ (function(module) {

module.exports = "/_next/static/images/IlloUseCaseActivateCustomerDataHover-b98a477d759ae848c780f46514a3e28b.png";

/***/ }),

/***/ 81755:
/***/ (function(module) {

module.exports = "/_next/static/images/IlloUseCaseBoostCrossSellDefault-37a46829a56fa921b7ee6b90ee71ac3a.png";

/***/ }),

/***/ 75201:
/***/ (function(module) {

module.exports = "/_next/static/images/IlloUseCaseBoostCrossSellHover-be38aec12bb3cbd0fb50728c9caa9a89.png";

/***/ }),

/***/ 76623:
/***/ (function(module) {

module.exports = "/_next/static/images/IlloUseCaseEnrichCustomerProfilesDefault-dcc470e609f32c8ec059b851f1091f94.png";

/***/ }),

/***/ 17571:
/***/ (function(module) {

module.exports = "/_next/static/images/IlloUseCaseEnrichCustomerProfilesHover-f04c741651b679066e99f1e3dcfabf89.png";

/***/ }),

/***/ 89755:
/***/ (function(module) {

module.exports = "/_next/static/images/IlloUseCaseOptimizeAdSpendDefault-4d4167dedfec4741c9b841c633441cc3.png";

/***/ }),

/***/ 96054:
/***/ (function(module) {

module.exports = "/_next/static/images/IlloUseCaseOptimizeAdSpendHover-5db51405cec3d79fe847da7d3dff3e82.png";

/***/ }),

/***/ 67883:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-c2329157d9695d50ba9ae0b25f9dfdfc.png";

/***/ }),

/***/ 59855:
/***/ (function(module) {

module.exports = "/_next/static/images/AIReadyData@2x-9f0b2884d7cdfd3a4077d5afc5fa6cc4.png";

/***/ }),

/***/ 50598:
/***/ (function(module) {

module.exports = "/_next/static/images/GenerativeAI@2x-3401374cd368d2fb168f57abc82d6582.png";

/***/ }),

/***/ 15020:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAI@2x-f2b0005c27e62e319c4c10d4f4b46730.png";

/***/ }),

/***/ 8010:
/***/ (function(module) {

module.exports = "/_next/static/images/SecurityAndPrivacy@2x-4d632ecb106ea90956cae4752b88f1c7.png";

/***/ }),

/***/ 26614:
/***/ (function(module) {

module.exports = "/_next/static/images/TheGrowthReport@2x-2043996a2080657e9b76df6497f4f106.png";

/***/ }),

/***/ 702:
/***/ (function(module) {

module.exports = "/_next/static/images/WarehouseData-c8a42234513c792e472cc2053a5d0c77.webp";

/***/ }),

/***/ 18501:
/***/ (function(module) {

module.exports = "/_next/static/images/WarehouseData@2x-c738effa51b895675d1a35257f23c940.webp";

/***/ }),

/***/ 40413:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-73e6e3a76c283d96d07947a991a9ad26.webp";

/***/ }),

/***/ 19903:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-863ce3cfc40983a3aa3ce74ef8499445.webp";

/***/ }),

/***/ 92439:
/***/ (function(module) {

module.exports = "/_next/static/images/AIReadyData-c00a1bb8a167735a8ad5fb6297a34ebe.webp";

/***/ }),

/***/ 8681:
/***/ (function(module) {

module.exports = "/_next/static/images/AIReadyData@2x-9f0b2884d7cdfd3a4077d5afc5fa6cc4.webp";

/***/ }),

/***/ 1318:
/***/ (function(module) {

module.exports = "/_next/static/images/GenerativeAI-689e6519f1508a3c2e2a07cf83cfd03e.webp";

/***/ }),

/***/ 47642:
/***/ (function(module) {

module.exports = "/_next/static/images/GenerativeAI@2x-3401374cd368d2fb168f57abc82d6582.webp";

/***/ }),

/***/ 88294:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAI-929fd8b7705206b3a2d7f68c6db838ae.webp";

/***/ }),

/***/ 40277:
/***/ (function(module) {

module.exports = "/_next/static/images/PredictiveAI@2x-f2b0005c27e62e319c4c10d4f4b46730.webp";

/***/ }),

/***/ 94401:
/***/ (function(module) {

module.exports = "/_next/static/images/SecurityAndPrivacy-9fc918ec106fed379b78af2f5ad4d07a.webp";

/***/ }),

/***/ 52375:
/***/ (function(module) {

module.exports = "/_next/static/images/SecurityAndPrivacy@2x-4d632ecb106ea90956cae4752b88f1c7.webp";

/***/ }),

/***/ 90004:
/***/ (function(module) {

module.exports = "/_next/static/images/TheGrowthReport-1e9d1055ccebeb5621f8491bb3cef919.webp";

/***/ }),

/***/ 39565:
/***/ (function(module) {

module.exports = "/_next/static/images/TheGrowthReport@2x-2043996a2080657e9b76df6497f4f106.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ }),

/***/ 28957:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ LayoutGroup; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(3422);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/DeprecatedLayoutGroupContext.mjs


/**
 * @deprecated
 */
var DeprecatedLayoutGroupContext = (0,react.createContext)(null);



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-force-update.mjs
var use_force_update = __webpack_require__(85886);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/group.mjs
var notify = function (node) {
    return !node.isLayoutDirty && node.willUpdate(false);
};
function nodeGroup() {
    var nodes = new Set();
    var subscriptions = new WeakMap();
    var dirtyAll = function () { return nodes.forEach(notify); };
    return {
        add: function (node) {
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: function (node) {
            var _a;
            nodes.delete(node);
            (_a = subscriptions.get(node)) === null || _a === void 0 ? void 0 : _a();
            subscriptions.delete(node);
            dirtyAll();
        },
        dirty: dirtyAll,
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/components/LayoutGroup/index.mjs








var shouldInheritGroup = function (inherit) { return inherit === true; };
var shouldInheritId = function (inherit) {
    return shouldInheritGroup(inherit === true) || inherit === "id";
};
var LayoutGroup = function (_a) {
    var _b, _c;
    var children = _a.children, id = _a.id, inheritId = _a.inheritId, _d = _a.inherit, inherit = _d === void 0 ? true : _d;
    // Maintain backwards-compatibility with inheritId until 7.0
    if (inheritId !== undefined)
        inherit = inheritId;
    var layoutGroupContext = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p);
    var deprecatedLayoutGroupContext = (0,react.useContext)(DeprecatedLayoutGroupContext);
    var _e = (0,tslib_es6/* __read */.CR)((0,use_force_update/* useForceUpdate */.N)(), 2), forceRender = _e[0], key = _e[1];
    var context = (0,react.useRef)(null);
    var upstreamId = (_b = layoutGroupContext.id) !== null && _b !== void 0 ? _b : deprecatedLayoutGroupContext;
    if (context.current === null) {
        if (shouldInheritId(inherit) && upstreamId) {
            id = id ? upstreamId + "-" + id : upstreamId;
        }
        context.current = {
            id: id,
            group: shouldInheritGroup(inherit)
                ? (_c = layoutGroupContext === null || layoutGroupContext === void 0 ? void 0 : layoutGroupContext.group) !== null && _c !== void 0 ? _c : nodeGroup()
                : nodeGroup(),
        };
    }
    var memoizedContext = (0,react.useMemo)(function () { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context.current), { forceRender: forceRender })); }, [key]);
    return (react.createElement(LayoutGroupContext/* LayoutGroupContext.Provider */.p.Provider, { value: memoizedContext }, children));
};




/***/ }),

/***/ 66057:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useElementScroll; }
/* harmony export */ });
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3105);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7622);
/* harmony import */ var _events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27723);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23617);
/* harmony import */ var hey_listen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9340);






var getElementScrollOffsets = function (element) { return function () {
    return {
        xOffset: element.scrollLeft,
        yOffset: element.scrollTop,
        xMaxOffset: element.scrollWidth - element.offsetWidth,
        yMaxOffset: element.scrollHeight - element.offsetHeight,
    };
}; };
/**
 * Returns MotionValues that update when the provided element scrolls:
 *
 * - `scrollX` — Horizontal scroll distance in pixels.
 * - `scrollY` — Vertical scroll distance in pixels.
 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
 *
 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const ref = useRef()
 *   const { scrollYProgress } = useElementScroll(ref)
 *
 *   return (
 *     <div ref={ref}>
 *       <motion.div style={{ scaleX: scrollYProgress }} />
 *     </div>
 *   )
 * }
 * ```
 *
 * @public
 */
function useElementScroll(ref) {
    var values = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useConstant */ .h)(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollMotionValues */ .w);
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function () {
        var element = ref.current;
        (0,hey_listen__WEBPACK_IMPORTED_MODULE_3__/* .invariant */ .k)(!!element, "ref provided to useScroll must be passed into a HTML element.");
        if (!element)
            return;
        var updateScrollValues = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollUpdater */ .S)(values, getElementScrollOffsets(element));
        var scrollListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "scroll", updateScrollValues);
        var resizeListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "resize", updateScrollValues);
        return function () {
            scrollListener && scrollListener();
            resizeListener && resizeListener();
        };
    }, []);
    return values;
}




/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ createScrollUpdater; },
/* harmony export */   "w": function() { return /* binding */ createScrollMotionValues; }
/* harmony export */ });
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40226);


function createScrollMotionValues() {
    return {
        scrollX: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollY: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollXProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollYProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
    };
}
function setProgress(offset, maxOffset, value) {
    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
}
function createScrollUpdater(values, getOffsets) {
    var update = function () {
        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
        // Set absolute positions
        values.scrollX.set(xOffset);
        values.scrollY.set(yOffset);
        // Set 0-1 progress
        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
    };
    update();
    return update;
}




/***/ }),

/***/ 77014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCombineMotionValues; }
/* harmony export */ });
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21687);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29709);
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76432);




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useMotionValue */ .c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMultiOnChange */ .f)(values, function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(updateValue, false, true); });
    return value;
}




/***/ }),

/***/ 85770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMotionTemplate; }
/* harmony export */ });
/* harmony import */ var _use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77014);


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return (0,_use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useCombineMotionValues */ .N)(values, buildValue);
}




/***/ }),

/***/ 21687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41412);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40226);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60976);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(function () { return (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._).isStatic;
    if (isStatic) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__read */ .CR)((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}




/***/ }),

/***/ 29709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15815);



function useOnChange(value, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}




/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(1560);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs
var use_combine_values = __webpack_require__(77014);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return (0,use_combine_values/* useCombineMotionValues */.N)(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7642,3287,9097,6577,3607,9137,3254,9129,7209,8834,4330,1382,4136,8392,2073,7096,2429,7303,4488,948,3996,8187,8726,7960,6012,3922,8536,4881,3379,814,8302,6278,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);